var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"Header"},[_vm._m(0),_c('div',{staticClass:"right"},[_c('ConnectWallet')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/applogo.png"),"alt":""}}),_c('div',{staticClass:"beta"},[_vm._v("Beta 0.1")]),_c('a',{staticClass:"to-index",attrs:{"href":"/"}})])
}]

export { render, staticRenderFns }